import api from 'dao/providers/axios';
import appconfig from 'config/appconfig';
import environment from 'lib/environment';

const extAdminUrl = { baseURL: environment.get().api.extAdminURL };
const extAdminMeEndpoint = appconfig.endpoints.extAdminMe;

export const daoAdminUrlget=()=> api.get(`${extAdminMeEndpoint}?includeAdmins=true&includeInvitation=true`, extAdminUrl);